module.exports = __webpack_public_path__ + "img/download-qr-code.5a70c817.png";